import { render, staticRenderFns } from "./head-logistics-duration.vue?vue&type=template&id=5a23686a&scoped=true&"
import script from "./head-logistics-duration.vue?vue&type=script&lang=js&"
export * from "./head-logistics-duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23686a",
  null
  
)

export default component.exports